module.exports = __webpack_public_path__ + "img/Doc18b_Shaelyn Lorensen.2c8081b8.jpg";